<template>
  <section class="py-5 about-section animate__animated animate__fadeInUp">
    <div class="container">
      <div class="row align-items-center g-4">

        <!-- Stânga: Text -->
        <div class="col-12 col-md-7 text-center text-md-start">
          <h2 class="mb-3 display-6 fw-bold text-primary">
            <i class="fas fa-building me-2"></i> Despre noi
          </h2>
          <p class="lead fs-6 text-muted mb-4">
            Cu peste <strong>10 ani de experiență</strong> în domeniul achizițiilor publice, sprijinim
            instituții și companii să navigheze cu succes procesul birocratic și legal.
            Punem accent pe <em>corectitudine, eficiență și rezultate concrete</em>.
          </p>
          <router-link to="/contact" class="btn btn-primary btn-sm px-4">
            <i class="fas fa-calendar-alt me-2"></i> Programează o consultanță
          </router-link>
        </div>

        <!-- Dreapta: Stats -->
        <div class="col-12 col-md-5">
          <div class="row g-3">
            <div class="col-6">
              <div class="stat-card text-center p-3 rounded-4 bg-white shadow-sm h-100">
                <div class="stat-number text-primary fw-bold">10+</div>
                <div class="stat-label text-muted small">Ani experiență</div>
              </div>
            </div>
            <div class="col-6">
              <div class="stat-card text-center p-3 rounded-4 bg-white shadow-sm h-100">
                <div class="stat-number text-primary fw-bold">500+</div>
                <div class="stat-label text-muted small">Clienți deserviți</div>
              </div>
            </div>
            <div class="col-6">
              <div class="stat-card text-center p-3 rounded-4 bg-white shadow-sm h-100">
                <div class="stat-number text-primary fw-bold">98%</div>
                <div class="stat-label text-muted small">Satisfacție clienți</div>
              </div>
            </div>
            <div class="col-6">
              <div class="stat-card text-center p-3 rounded-4 bg-white shadow-sm h-100">
                <div class="stat-number text-primary fw-bold">1000+</div>
                <div class="stat-label text-muted small">Proceduri gestionate</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<style scoped>
.about-section {
  background: linear-gradient(145deg, #f7f9fc, #ffffff);
}

.stat-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
}

.stat-number {
  font-size: 1.8rem;
  line-height: 1.2;
}

.stat-label {
  font-size: 0.78rem;
  margin-top: 0.2rem;
}

@media (max-width: 576px) {
  .stat-number {
    font-size: 1.5rem;
  }
  .lead {
    font-size: 0.95rem !important;
  }
}
</style>